module.exports = __webpack_public_path__ + "2a0abba5204cb475e1e1179a97ffa726.jpg";